module.exports = __webpack_public_path__ + "img/D9.100c86ac.svg";